@if (isLoading) {
  <div class="overlay full" id="productDetails-loadingSpinner">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <mat-spinner id="productsLoader"></mat-spinner>
  </div>
}

<div *appIsDesktop>
  @if (isContentVisible) {
    @if (product) {
      <div class="content">
        <div class="breadcrumbs-and-search">
          <div class="breadcrumbs-wrapper">
            <a id="productDetails-breadcrumbHome" class="breadcrumb-span" [routerLink]="['/tools/categories', catalogCode]">
            {{ catalogName }}</a>
            <span class="crm-industrial-font icon-right"></span>
            @for (category of product.breadcrumb; track category) {
              <span class="breadcrumb-span">
                <a [id]="'productDetails-breadcrumbCategory_' + category.name"
                [routerLink]="['/tools/categories', catalogCode, category.id]"> {{category.name}} </a>
                <span class="crm-industrial-font icon-right"></span>
              </span>
            }
            <span id="productDetails-breadcrumbPartName" class="current-category-breadcrumb"
            [innerHtml]="product.partName | safe: 'html'"></span>
          </div>
          <app-search-product></app-search-product>
        </div>
        <div id="firstSection" class="container">
          <!-- Images carousel -->
          <div id="carouselContainer" class="img-carousel">
            @if (catalogLogo) {
              <img [src]="catalogLogo" alt="catalog logo" class="catalog-logo-overlay">
            }
            <app-product-images [items]="images" (imageChanged)="onImageChange($event)"></app-product-images>
            @if (displayZoomBtn) {
              <button id="carouselZoomButton" mat-button class="button zoom-btn"
                (click)="openCarousel($event, false)">
                <span class="crm-industrial-font icon-zoom-in material-icons zoom-btn-icon"></span>
              </button>
            }
          </div>
          <!-- General Info section -->
          <div id="generalInfoContainer" class="details">
            <h3 id="productDetails-productPartName" [innerHtml]="product.partName | safe: 'html'"></h3>
            <table id="generalInfoTable" class="features-table isc-table">
              <tr id="sku">
                <th id="skuLabel">
                  <p>{{ appStrings.products_gridSku }}</p>
                </th>
              </tr>
              <tr id="productNumber">
                <td id="productDetails-productNumber" class="product-number">{{ product.productNumber }}</td>
              </tr><br>
              <tr id="labelSupersedeManufacturer">
                <th id="labelSupersede">{{ appStrings.products_gridSupersede }}</th>
                <th id="labelManufacturer">{{ appStrings.products_gridManufacturer }}</th>
              </tr>
              <tr id="valueSupersedeManufacturer">
                <td id="valueSupersede">{{ product.supersede }}</td>
                <td id="valueManufacturer">{{ product.manufacturer }}</td>
              </tr>
              <tr id="labelLifecycleReturnable">
                <th id="labelLifecycle">{{ appStrings.products_gridLifecycle }}</th>
                <th id="labelReturnable">{{ appStrings.products_gridReturnable }}</th>
              </tr>
              <tr id="valueLifecycleReturnable">
                <td id="valueLifecycle">{{ product.lifecycle }}</td>
                <td id="valueReturnable">{{ product.returnable }}</td>
              </tr>
              <tr id="labelComodityCodeRepairable">
                <th id="labelComodityCode">{{ appStrings.products_gridCommodityCode }}</th>
                <th id="labelRepairable">{{ appStrings.products_gridRepairable }}</th>
              </tr>
              <tr id="valueComodityCodeRepairable">
                <td id="valueComodityCode">{{ product.commodityCode }}</td>
                <td id="valueRepairable">{{ product.repairable }}</td>
              </tr>
              <tr id="labelWeightCountryOfOrigin">
                <th id="labelWeight">{{ appStrings.products_weight }}</th>
                <th id="labelCountryOfOrigin">{{ appStrings.products_gridCountryOfOrigin }}</th>
              </tr>
              <tr id="valueWeightCountryOfOrigin">
                <td id="valueWeight">{{ product.weight }}</td>
                <td id="valueCountryOfOrigin">{{ product.countryOfOrigin }}</td>
              </tr>
              <tr id="labelSinDirectDelivery">
                <th id="labelSin">{{ appStrings.products_SIN }}</th>
                <th id="labelDirectDelivery">{{ appStrings.products_gridDirectDelivery }}</th>
              </tr>
              <tr id="valueSinDirectDelivery">
                <td id="valueSin">{{ product.sin }}</td>
                <td id="valueDirectDelivery">{{ product.directDelivery }}</td>
              </tr>
              <tr id="labelWarrantyPrice">
                <th id="labelWarranty">{{ appStrings.products_gridWarrantyCode }}</th>
                <th id="labelPrice">{{ appStrings.products_gridPriceCategory }}</th>
              </tr>
              <tr id="valueWarrantyPrice">
                <td id="valueWarranty">{{ product.warrantyCode }}</td>
                <td id="valuePrice">{{ product.priceCategory }}</td>
              </tr>
              <tr id="labelSignalCodeMinQty">
                <th id="labelSignalCode">{{ appStrings.products_gridSignalCode }}</th>
                <th id="labelMinQty">{{ appStrings.products_gridMinimumQuantity }}</th>
              </tr>
              <tr id="valueSignalCodeMinQty">
                <td id="valueSignalCode">{{ product.signalCode }}</td>
                <td id="valueMinQty">{{ product.minimumQuantity }}</td>
              </tr>
              <tr id="labelAlternateLimited">
                <th id="labelAlternate">{{ appStrings.products_gridAlternateProduct }}</th>
                <th id="labelLimited">{{ appStrings.products_gridLimitedMarketing }}</th>
              </tr>
              <tr id="valueAlternateLimited">
                <td id="valueAlternate">{{ product.alternateProduct }}</td>
                <td id="valueLimited">{{ product.limitedMarketing }}</td>
              </tr>
            </table>
          </div>
          <div class="price-as-container float-right">
            <app-price-as [initialPrice]="productPrice" [productNumber]="product.productNumber" [catalogCode]="catalogCode"></app-price-as>
          </div>
        </div>
        <!-- Additional Info section -->
        <mat-expansion-panel hideToggle id="productAdditionalInfoContainer" class="product-info"
          [expanded]="additionalInfoOpen">
          <mat-expansion-panel-header id="productAdditionalInfoHeader" (click)="displayAdditionalInfo()">
            <div id="additionalInfoHeaderContainer" class="product-info-header">
              <span id="productAddInfoHeaderClosed" class="crm-industrial-font icon-right"></span>
              <span id="productAddInfoHeaderOpened" class="crm-industrial-font icon-down"></span>
              <h3 id="productAddInfoLabel" class="product-section-label">{{ appStrings.product_additionalInfo }}</h3>
            </div>
          </mat-expansion-panel-header>
          <div id="productAdditionalInfoContent" class="product-additional-info">
            <ng-container *ngTemplateOutlet="additionalInfo"></ng-container>
          </div>
        </mat-expansion-panel>
        <!-- Availability section -->
        <mat-expansion-panel hideToggle id="productAvailabilityInfoContainer" class="product-info"
          [expanded]="availabilityOpen">
          <ng-container *ngTemplateOutlet="loader; context: { condition: availabilityIsLoading, selector: 'availability' }"></ng-container>
          <mat-expansion-panel-header id="productAvailabilityHeader" (click)="displayAvailabilityInfo()">
            <div id="availabilityHeaderContainer" class="product-info-header">
              <span id="productAvailabilityHeaderClosed" class="crm-industrial-font icon-right"></span>
              <span id="productAvailabilityHeaderOpened" class="crm-industrial-font icon-down"></span>
              <h3 id="productAvailabilityLabel" class="product-section-label">{{appStrings.product_availability}}</h3>
            </div>
          </mat-expansion-panel-header>
          <div id="productAvailabilityContent">
            <table id="availabilityInfoTable" class="availability-table">
              <tr id="warehouseName" class="warehouse-name">
                <th id="productNumberLabel">{{ appStrings.product_numberAvailability }}</th>
                @for (warehouse of productWarehouses; track warehouse; let index = $index) {
                  <th [id]="'warehouse-'+index">{{
                  warehouse.warehouseName }}</th>
                }
              </tr>
              <tr id="warehouseAvailableQuantity" class="available-quantity">
                <td id="availabilityProductNumber">{{ product.productNumber }}</td>
                @for (warehouse of productWarehouses; track warehouse; let index = $index) {
                  <td [id]="'availability-warehouse-'+index">
                  {{ warehouse.quantityOnDeliveryDate }}</td>
                }
              </tr>
            </table>
          </div>
        </mat-expansion-panel>
        <!-- Warranty section -->
        <mat-expansion-panel hideToggle id="productWarrantyContainer" class="product-info" [expanded]="warrantyOpen">
          <mat-expansion-panel-header id="productWarrantyHeader" (click)="displayWarrantyInfo()">
            <div id="warrantyHeaderContainer" class="product-info-header">
              <span id="productWarrantyHeaderClosed" class="crm-industrial-font icon-right"></span>
              <span id="productWarrantyHeaderOpened" class="crm-industrial-font icon-down"></span>
              <h3 id="productWarrantyLabel" class="product-section-label">{{ appStrings.product_warranty }}</h3>
            </div>
          </mat-expansion-panel-header>
          <div id="productWarrantyContent" class="details-area">
            <span id="warrantyDetails" class="product-description"
            [innerHtml]="warrantySpecs.description | safe: 'html'"></span>
          </div>
        </mat-expansion-panel>
        <!-- Specifications section -->
        <mat-expansion-panel hideToggle id="productSpecificationsContainer" class="product-info"
          [expanded]="specificationsOpen">
          <mat-expansion-panel-header id="productSpecificationsHeader" (click)="displaySpecifications()">
            <div id="specificationsHeaderContainer" class="product-info-header">
              <span id="productSpecificationsHeaderClosed" class="crm-industrial-font icon-right"></span>
              <span id="productSpecificationsHeaderOpened" class="crm-industrial-font icon-down"></span>
              <h3 id="productSpecificationsLabel" class="product-section-label">{{ appStrings.product_specifications }}</h3>
            </div>
          </mat-expansion-panel-header>
          <div id="specificationsContainer" class="specifications-content">
            <ng-container *ngTemplateOutlet="specifications"></ng-container>
          </div>
        </mat-expansion-panel>
      </div>
    } @else {
      <p id="productDetails-productNotFound">{{ appStrings.products_productNotFound }}</p>
    }
  }
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  @if (isContentVisible) {
    @if (product) {
      <div class="content">
        <app-breadcrumbs [breadcrumb]="product.breadcrumb" [currentCategory]="product.partName" [catalogCode]="catalogCode" [catalogName]="catalogName"></app-breadcrumbs>
        <app-search-product></app-search-product>
        <div class="carousel-container card">
          <div class="title">
            <span>{{ appStrings.menu_Products }}</span>
          </div>
          <div class="product-name">
            <span>{{ product.productNumber }} / {{ product.partName }}</span>
          </div>
          <div id="carouselContainer" class="img-carousel">
            @if (catalogLogo) {
              <img [src]="catalogLogo" alt="catalog logo" class="catalog-logo-overlay">
            }
            <app-product-images [items]="images" (imageChanged)="onImageChange($event)"></app-product-images>
          </div>
        </div>
        <div class="price-as-container card">
          <app-price-as [initialPrice]="productPrice" [productNumber]="product.productNumber" [catalogCode]="catalogCode"></app-price-as>
        </div>
        <div class="general-info-container card">
          <mat-expansion-panel hideToggle id="generalInfoContainer" [expanded]="generalInfoOpen">
            <mat-expansion-panel-header id="generalInfoHeader" (click)="displayGeneralInfo()">
              <ng-container *ngTemplateOutlet="accordionHeader; context: { label: appStrings.product_generalInfo, selector: 'generalInfo' }"></ng-container>
            </mat-expansion-panel-header>
            <div id="general-info-content" class="accordion-content">
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridSku, selector: 'productNumber' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridSupersede, selector: 'supersede' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridManufacturer, selector: 'manufacturer' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridLifecycle, selector: 'lifecycle' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridReturnable, selector: 'returnable' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridCommodityCode, selector: 'commodityCode' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridRepairable, selector: 'repairable' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_weight, selector: 'weight' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridCountryOfOrigin, selector: 'countryOfOrigin' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_SIN, selector: 'sin' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridDirectDelivery, selector: 'directDelivery' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridWarrantyCode, selector: 'warrantyCode' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridPriceCategory, selector: 'priceCategory' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridSignalCode, selector: 'signalCode' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridMinimumQuantity, selector: 'minimumQuantity' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridAlternateProduct, selector: 'alternateProduct' }"></ng-container>
              <ng-container *ngTemplateOutlet="generalInfoRow; context: { label: appStrings.products_gridLimitedMarketing, selector: 'limitedMarketing' }"></ng-container>
            </div>
          </mat-expansion-panel>
        </div>
        <div class="card">
          <mat-expansion-panel hideToggle id="productAdditionalInfoContainer" class="product-info" [expanded]="additionalInfoOpen">
            <ng-container *ngTemplateOutlet="loader; context: { condition: additionalInfoIsLoading }"></ng-container>
            <mat-expansion-panel-header id="productAdditionalInfoHeader" (click)="displayAdditionalInfo()">
              <ng-container *ngTemplateOutlet="accordionHeader; context: { label: appStrings.product_additionalInfo, selector: 'productAddInfo' }"></ng-container>
            </mat-expansion-panel-header>
            <div id="productAdditionalInfoContent" class="accordion-content">
              @if (hasAdditionalInfo) {
                <div>
                  <ng-container *ngTemplateOutlet="additionalInfo"></ng-container>
                </div>
              } @else {
                <p id="productDetails-notApplicable" class="details-area">{{ appStrings.notApplicable }}</p>
              }
            </div>
          </mat-expansion-panel>
        </div>
        <div class="card">
          <mat-expansion-panel hideToggle id="productAvailabilityInfoContainer" class="product-info" [expanded]="availabilityOpen">
            <ng-container *ngTemplateOutlet="loader; context: { condition: availabilityIsLoading }"></ng-container>
            <mat-expansion-panel-header id="productAvailabilityHeader" (click)="displayAvailabilityInfo()">
              <ng-container *ngTemplateOutlet="accordionHeader; context: { label: appStrings.product_availability, selector: 'availability' }"></ng-container>
            </mat-expansion-panel-header>
            <div class="accordion-content">
              <div id="skuContainer" class="table-info-row">
                <p id="skuLabel" class="label">{{ appStrings.product_numberAvailability }}</p>
                <p id="sku" class="data">{{ product.productNumber }}</p>
              </div>
              @for (warehouse of productWarehouses; track warehouse; let index = $index) {
                <div id="warehouseContainer" class="table-info-row">
                  <p id="warehouseLabel" class="label">{{  warehouse.warehouseName }}</p>
                  <p id="quantity" class="data">{{ warehouse.quantityOnDeliveryDate }}</p>
                </div>
              }
            </div>
          </mat-expansion-panel>
        </div>
        <div class="card">
          <mat-expansion-panel hideToggle id="productWarrantyContainer" class="product-info" [expanded]="warrantyOpen">
            <mat-expansion-panel-header id="productAvailabilityHeader" (click)="displayWarrantyInfo()">
              <ng-container *ngTemplateOutlet="accordionHeader; context: { label: appStrings.product_warranty, selector: 'warranty' }"></ng-container>
            </mat-expansion-panel-header>
            <div id="productWarrantyContent" class="accordion-content">
              <span id="warrantyDetails" class="product-description"
              [innerHtml]="warrantySpecs.description | safe: 'html'"></span>
            </div>
          </mat-expansion-panel>
        </div>
        <div class="card">
          <mat-expansion-panel hideToggle id="productSpecificationsContainer" class="product-info" [expanded]="specificationsOpen">
            <mat-expansion-panel-header id="productAvailabilityHeader" (click)="displaySpecifications()">
              <ng-container *ngTemplateOutlet="accordionHeader; context: { label: appStrings.product_specifications, selector: 'specifications' }"></ng-container>
            </mat-expansion-panel-header>
            <div id="specificationsContainer" class="accordion-content">
              <ng-container *ngTemplateOutlet="specifications"></ng-container>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    } @else {
      <p id="productDetails-productNotFound">{{ appStrings.products_productNotFound }}</p>
    }
  }
</div>

<!-- common -->


<ng-template #loader let-condition="condition" let-selector="selector">
  @if (condition) {
    <div id="loadingSpinner" class="overlay-availability">
      <p id="loadingText" class="text-center">{{ appStrings.pleaseWait }}</p>
      <mat-spinner id="{{ selector }}Loader"></mat-spinner>
    </div>
  }
</ng-template>

<ng-template #accordionHeader let-label="label" let-selector="selector">
  <div id="{{ selector }}HeaderContainer" class="accordion-header">
    <h3 id="{{ selector }}Label" class="product-section-label">{{ label }}</h3>
    <span id="{{ selector }}HeaderClosed" class="crm-industrial-font icon-keyboard-arrow-up"></span>
    <span id="{{ selector }}HeaderOpened" class="crm-industrial-font icon-keyboard-arrow-down"></span>
  </div>
</ng-template>

<ng-template #generalInfoRow let-label="label" let-selector="selector">
  <div id="{{ selector }}Container" class="table-info-row">
    <p id="{{ selector }}Label" class="label">{{ label }}</p>
    <p id="{{ selector }}" class="data">{{ product[selector] ?? "-" }}</p>
  </div>
</ng-template>

<ng-template #additionalInfo>
  @if (hasAdditionalInfo) {
    <div>
      <div id="addInfoDetails">
        <span id="addInfoDetails" class="product-description"
        [innerHtml]="productInfo.description | safe: 'html'"></span>
      </div>
      @if (videoSource) {
        <div id="addInfoVideo" class="media-area">
          <video id="additionalInfoVideo" class="additional-info-video" (play)="toggleFullscreen()" preload="auto"
            controls loop [muted]="'muted'">
            <source src={{videoSource}} type="video/mp4">
          </video>
        </div>
      }
    </div>
  } @else {
    <p id="productDetails-notApplicable" class="details-area">{{ appStrings.notApplicable }}</p>
  }
</ng-template>

<ng-template #specifications>
  @if (hasSpecifications) {
    <div id="specificationsDetails" class="specifications-area">
      @if (specList.length) {
        <table id="specificationsDetailsTable" class="specs-table" mat-table
          [dataSource]="specList">
          <ng-container matColumnDef="specName">
            <td class="spec-name" mat-cell *matCellDef="let specName">{{ specName.specificationName }}</td>
          </ng-container>
          <ng-container matColumnDef="value">
            <td class="spec-value" mat-cell *matCellDef="let specValue">{{ specValue.specificationValue }}</td>
          </ng-container>
          <tr mat-row *matRowDef="let specRow; columns: displayedColumns;"></tr>
        </table>
      }
    </div>
  } @else {
    <p id="productDetails-notApplicable" class="details-area">{{ appStrings.notApplicable }}</p>
  }
  <div id="specificationsImageContainer" class="image-area">
    @if (displaySpecZoomBtn) {
      <img id="specificationsImage" class="specifications-img"
        [src]="specificationImage" />
    }
  </div>
</ng-template>